<template>
  <el-main>
    <users />
  </el-main>
</template>

<script>
  // components
  import Users from './users/Users';

  export default {
    name: 'PageContent',
    components: {
      Users
    },
  }
</script>
